<script>
  import { mapGetters, mapMutations } from "vuex";
  import sessionsApi from "../../common/api/sessionsAxios";
  export default {
    data() {
      return {
        newPassword: "",
        confirmedPassword: "",
        error: true,
      };
    },
    computed: {
      passwordNotValid() {
        return this.error;
      },
      passwordsDontMatch() {
        return this.newPassword !== this.confirmedPassword;
      },
    },
    methods: {
      ...mapGetters("user", { getUserId: "getUserId" }),
      ...mapMutations("user", { setQueryUser: "setQueryUser", setAuthMethods: "setAuthMethods" }),

      verifyPasswordRegex(input) {
        const validPasswordRegex = /^(?=.*[A-Z])(?=.*[°|¬!"@#$%&/()=?\\¡¿?'+*~´¨`}\]{^_:.;,\<\>/\+-])[A-Za-z0-9°|¬!"@#$%&/()=?\\¡¿?'+*~´¨`}\]{^_:.;,\<\>/\+-]{6,}$/;
        return validPasswordRegex.test(this[input]);
      },

      verifyInput(event) {
        const { target } = event;
        const { name } = target;

        if (name === "newPassword") {
          this.error = !this.verifyPasswordRegex(name);
        }
      },

      successChangePass() {
        this.setQueryUser(null);
        this.setAuthMethods([]);
        this.$toast.success("Su contraseña ha sido modificada.");

        setTimeout(() => {
          this.$router.push({ name: "login" });
        }, 2000);
      },

      async changePassword() {
        if (!this.passwordsDontMatch) {
          const requestBody = {
            userId: this.getUserId(),
            newPassword: this.newPassword,
          };

          const {
            data: { error, details },
          } = await sessionsApi.post("/auth/changePassword", requestBody);

          if (error) {
            this.$toast.error(details);
            return;
          } else {
            this.successChangePass();
          }
        } else {
          this.$toast.error("Las contraseñas no coinciden");
        }
      },
    },
  };
</script>
<template>
  <form class="newPassword" @submit.prevent>
    <h1 class="newPassword__title">Ingresa tu nueva contraseña</h1>
    <input
      :class="`newPassword__input newPassword__input--${passwordNotValid ? 'error' : 'verified'}`"
      type="password"
      placeholder="Nueva contraseña"
      v-model="newPassword"
      autocomplete="off"
      @input="verifyInput"
      name="newPassword"
    />
    <input
      :class="`newPassword__input newPassword__input--${passwordsDontMatch ? 'error' : ''}`"
      type="password"
      placeholder="Confirma contraseña"
      v-model="confirmedPassword"
      autocomplete="off"
      @keyup="verifyInput"
      name="confirmedPassword"
      :disabled="error"
    />

    <ul class="newPassword__specs">
      <li>La nueva contraseña debe tener mínimo 6 caracteres.</li>
      <li>La nueva contraseña debe contener al menos un caracter especial.</li>
      <li>La nueva contraseña debe contener al menos un caracter en mayúscula.</li>
    </ul>
    <button class="newPassword__submit" @click="changePassword" :disabled="passwordsDontMatch || passwordNotValid">Enviar</button>
  </form>
</template>
<style lang="scss">
  .newPassword {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0 auto;
    padding: 10px 0;
    width: 100%;
    max-width: 425px;

    &__title {
      text-transform: none;
      font-family: $newFont;
      font-size: 18px;
      text-align: center;
    }

    &__input {
      width: 90%;
      border: 1px solid #e9edef;
      border-radius: 8px;
      padding: 8px 10px;
      font-family: $newFont_regular;
      font-size: 14px;

      &--error {
        border-color: $lipstick;
      }

      &--verified {
        border-color: $la_palma;
      }
    }

    &__specs {
      font-size: 13px;
      width: 80%;
      font-family: $newFont_regular;
      li {
        margin-bottom: 5px;
        list-style: circle;
        list-style-position: outside;
        list-style-type: disc;
      }
    }

    &__submit {
      width: 90%;
      color: $white;
      background-color: $lipstick;
      border: none;
      border-radius: 8px;
      height: 40px;
      transition: all ease-in 0.3s;
      font-family: $newFont_semiBold;

      &:hover {
        opacity: 0.5;
      }
    }

    @include tabletWidth() {
      .newPassword {
        &__title,
        &__specs {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>
